import { useMemo } from 'react'
import { areMaterialRequirementsHandled } from '../../../../../../../../helpers/entities/shipment/are-material-requirements-handled'
import { DataSourceItem } from '../../../../../../shipments-page'
import { useMaterialRequirementsStocks } from './use-material-requirements-stocks'

export const useMaterialRequirementsHandled = (record: DataSourceItem | undefined) => {
    const stocks = useMaterialRequirementsStocks(record)

    return useMemo(() => areMaterialRequirementsHandled(record, stocks), [record, stocks])
}
